(function($, undefined) {
	
	'use strict';
	var promotionsAllActionsBtn;
	var promotionsActionBtn;
	var outerCtn;
	var buttonChoiceBtn;
	var buttonSizeRangeBtn;
	var colorPickerBtn;
	var buttonTextInput;
	var backToButtonChoicesBtn;
	var addFavorTicketsBtn;
	var addFavorTicketsRecipientBtn;
	var delFavorTicketsRecipientBtn;
	var eventDisplayBtn;
	var eventTypeBtn;

	var blackoutPromotionsEvents = function() {
		var t = $(this);
		var parentEvent = t.closest('.promotions-one-event-outer-ctn');

		parentEvent.removeClass('one-action-open');
		parentEvent.find('.promotions-action-ctn.open').removeClass('open').slideUp(300);

		if (!$('.promotions-one-event-outer-ctn').hasClass('actions-open')) {
			$('.promotions-one-event-outer-ctn').addClass('actions-open');
		} else {
			$('.promotions-one-event-outer-ctn').removeClass('actions-open');
		}
	};

	var closePromotionsActionPopup = function(t) {
		$('.promotions-one-event-outer-ctn').removeClass('actions-open');
		t.closest('.table-actions-ctn').removeClass('open');
		t.closest('.table-action-btns-ctn').find('.table-action-popup-btn').removeClass('active');
	};

	var showActionRelatedContent = function() {
		var t = $(this);
		var action = t.attr('data-id');
		var parentEvent = t.closest('.promotions-one-event-outer-ctn');

		parentEvent.addClass('one-action-open');
		parentEvent.find('.promotions-action-ctn.' + action).slideDown(300, function() {
			$(this).addClass('open');
		});
		closePromotionsActionPopup(t);
	};


	// CUSTOMIZE BUTTON FUNCTIONS

	var getButtonChoice = function () {
		var t = $(this);
		var parent = t.closest(outerCtn);
		var choice = t.val();
		var button = t.closest('.button-style-choice-option-outer-ctn').find('.epasslive-button');
		var height = button.outerHeight();
		var width = button.outerWidth();

		$('.customize-button-text.shape-choice', parent).fadeOut(300, function() {
			$('.customize-button-text.personalize', parent).fadeIn(300);
		});

		$('.button-style-choice-option-outer-ctn:not(.' + choice + ')', parent).fadeOut(300, function() {
			$(this).addClass('hide');
			$('.promotions-button-all-options-ctn', parent).addClass('flex-justify-center');
		});

		$('.promotions-disabled-button-customisation-overlay', parent).fadeOut(300, function() {
			$('.custom-btn-range-input.height', parent).val(height).attr('min', button.attr('data-min-height'));
			$('.custom-btn-range-input.width', parent).val(width).attr('min', button.attr('data-min-width'));
			changeButtonSizeText(parent, button.outerHeight(), button.outerWidth());

			if (choice === 'a' || choice === 'b') {
				$('.custom-btn-range-input', parent).addClass('square');
			}
		});
		$('.promotions-custom-button-back-to-choices-btn', parent).fadeIn(300);

		$('.promotions-button-code-step-outer-ctn', parent).slideDown(300, function() {
			updateButtonCode(button);
		});
	};

	var changeButtonSize = function() {
		var t = $(this);
		var size = t.val();
		var parent = t.closest(outerCtn);
		var chosenButton = parent.find('.button-style-choice-option-outer-ctn:not(.hide)').find('.epasslive-button');
		var height = null;
		var width = null;

		if (t.hasClass('square')) {
			height = size;
			width = size;

			parent.find(buttonSizeRangeBtn).val(size);
		} else {
			if (t.hasClass('width')) {
				width = size;
			} 
			if (t.hasClass('height')) {
				height = size;
			}
		}

		if (height !== null) {
			chosenButton.css('height', height + 'px');
		}

		if (width !== null) {
			chosenButton.css('width', width + 'px');
		}

		changeButtonSizeText(parent, height, width);
		updateButtonCode(chosenButton);
	};

	var changeButtonSizeText = function(parent, height, width) {
		if (height) {
			$('.custom-button-size.height', parent).html('(' + parseInt(height) + 'px)');
		}

		if (width) {
			$('.custom-button-size.width', parent).html('(' + parseInt(width) + 'px)');
		}
	};

	var changeButtonColor = function() {
		var t = $(this);
		var color = MG2.ColorPicker.getColor();
		var id = t.attr('data-inp').split('color-')[1];
		var parent = t.closest('.box-theme-content').find('.promotions-one-event-outer-ctn[data-id=' + id + ']');
		var chosenButton = parent.find('.button-style-choice-option-outer-ctn:not(.hide)').find('.epasslive-button');
		var button = parent.find('.button-style-choice-option-outer-ctn').find('.epasslive-button');
		var modifType = t.attr('data-inp').split('-'+id)[0];
		
		t.closest('.popup-ctn').find('.popup-inner-close').trigger('click');
		if (modifType.indexOf('text') !== -1) {
			button.find('.epasslive-button-text').css('color', color);
			button.find('svg').css('fill', color);
		} else {
			button.css(modifType, color);
		}

		updateButtonCode(chosenButton);
	};

	var changeButtonText = function() {
		var t = $(this);
		var parent = t.closest(outerCtn);
		var button = parent.find('.button-style-choice-option-outer-ctn').find('.epasslive-button');
		var chosenButton = parent.find('.button-style-choice-option-outer-ctn:not(.hide)').find('.epasslive-button');
		
		button.find('.epasslive-button-text').text(t.val());

		updateButtonCode(chosenButton);
	};

	var updateButtonCode = function(button) {
		var codeCtn = button.closest(outerCtn).find('.promotions-generate-btn-step-ctn.button-code-ctn');
		var eventUrl = codeCtn.attr('data-url');
		var style = '';
		var classNames = button.attr('class').split(' ');

		classNames.forEach(function(e) {
			var eStyles = getStyle('.' + e);

			if (eStyles !== undefined) {
				style += eStyles;
			}
		});

		if (button.attr('style') !== undefined) {
			style += button.attr('style');
		}

		codeCtn.find('textarea').val('<a href="' + eventUrl + '" target="_blank" style="text-decoration:none;margin:20px;display:inline-block;"><div style="height:' + button.attr('data-min-height') + 'px;width:' + button.attr('data-min-width') + 'px;' + style + '">' + button.html() + '</div></a>');
	};

	// keeps color choices and text (applied to all buttons), resets other elements
	var showAllButtonChoices = function() {
		var parent = $(this).closest(outerCtn);

		$('.button-style-choice-btn', parent).prop('checked', false);

		$('.customize-button-text.personalize', parent).fadeOut(300, function() {
			$('.customize-button-text.shape-choice', parent).fadeIn(300);
		});

		$('.promotions-button-all-options-ctn', parent).removeClass('flex-justify-center');
		$('.button-style-choice-option-outer-ctn', parent).fadeIn(300, function() {
			$(this).removeClass('hide');
		});
		$('.promotions-disabled-button-customisation-overlay', parent).fadeIn(300);
		$('.custom-btn-range-input', parent).removeClass('square');
		$('.custom-button-size', parent).html('');

		$('.promotions-custom-button-back-to-choices-btn', parent).fadeOut(300);

		$('.promotions-button-code-step-outer-ctn', parent).slideUp(300, function() {
			$('.button-code-ctn', parent).find('textarea').val('');
		});
	};
    
    var addFavorTickets = function(){
        var t = $(this);
        var eventId = t.attr("data-id");
        var ctn = t.closest(".popup-content-ctn");
        var form = t.closest('.js-form');
        var valid = true;
        
        var ticketIds = "";
        var qtys = "";
        var links = "";
        var names = "";
        var emails = "";

        // if (ctn.find(".page-promotions-tickets-warning input").is(":checked")) {

        // } else {
        // 	form.addClass('error-checkbox');
        // }

        formValidator.validateForm(form);
        
        ctn.find(".promotions-send-free-tickets-form-inputs-outer-ctn .free-ticket-promotion-line").each(function(){
            var qty = $(this).find(".qty-input-with-buttons input").val();
            var tId = $(this).find(".promotions-free-tickets-category-select").val();
            var linked = $(this).find(".promotions-free-tickets-category-select").find(":selected").attr("data-tickets");
            var name = $(this).find(".promotions-free-tickets-name input").val();
            var email = $(this).find(".promotions-free-tickets-email input").val();
            if ((qty !== "0" && qty !== undefined && qty !== "") && tId !== "" && name !== "" && email !== "") {
                $(this).find(".qty-input-with-buttons").removeClass("error");
                ticketIds += tId + ",";
                qtys += qty + ",";
                links += (linked === undefined) ? "X," : linked+",";
                names += encodeURIComponent(name) + ",";
                emails += encodeURIComponent(email) + ",";
            } else {
                valid = false;
                if (!(qty !== "0" && qty !== undefined && qty !== "")) {
                    $(this).find(".qty-input-with-buttons").addClass("error");
                } else {
                    $(this).find(".qty-input-with-buttons").removeClass("error");                    
                }
            } 
        });

        if (valid && !form.hasClass('has-error')) {
        	t.addClass('disabled');

            var url = "/action/epFavorTickets";
            url += "?eventId=" + eventId;
            url += "&ticketIds="+ticketIds;
            url += "&qtys="+qtys;
            url += "&linkedTicketIds="+links;
            url += "&names="+names;
            url += "&emails="+emails;
            ajax(url, function(response) {
                ctn.find(".page-promotions-tickets-warning input").prop("checked", false);
                ctn.find(".free-ticket-form-success").slideDown();
                ctn.find(".free-ticket-form-ctn").slideUp();
                ctn.find(".free-ticket-promotion-line:gt(0)").each(function(index) {
                    if (index === 0) {
                        $(this).find(".promotions-free-tickets-category-select-ctn").removeClass('focused').find('select').removeClass('success').val("");
                        $(this).find(".qty-input-with-buttons").removeClass('focused').find('input').val("");
                        $(this).find(".promotions-free-tickets-name").removeClass('focused').find('input').removeClass('success').val("");
                        $(this).find(".promotions-free-tickets-email").removeClass('focused').find('input').removeClass('success').val("");
                    } else {
                        $(this).slideUp("fast", function() {
                            $(this).remove();
                        });
                    }
                });

                window.setTimeout(function() {
                    ctn.find(".free-ticket-form-success").slideUp();
                    ctn.find(".free-ticket-form-ctn").slideDown();
                    t.removeClass('disabled');
                }, 3000);
            }, true);
        }
    };
    
    var addFavorTicketsRecipient = function(){        
        var t = $(this);
        var ctn = t.closest(".popup-content-ctn");
        
        var model = ctn.find(".promotions-free-tickets-model").children().clone(true);
        model.addClass("clone");
        model.find('.form-input:not(.numbers-only)').addClass('required').blur(function() {
        	formValidator.formItemsBlur($(this));
        });
        ctn.find(".promotions-send-free-tickets-form-inputs-outer-ctn").append(model);
        model.removeClass("clone");  
    };
    
    var delFavorTicketsRecipient = function(){        
        var t = $(this);
        t.closest(".free-ticket-promotion-line").slideUp("fast",function(){$(this).remove();});
    };

    var changeEventDisplayStyle = function() {
    	var t = $(this);
    	var ctn = t.closest('.box-theme-ctn');
    	var initCode = ctn.find('textarea').html();
    	var codeCtn = ctn.find('.code-promotions');
    	var code = codeCtn.attr('data-prefix');
   
    	if (t.hasClass('promotions-profile-events-style-btn')) {
    		$('.promotions-profile-events-style-btn').removeClass('selected');
    		t.addClass('selected');
    	}

    	if ((t.hasClass('change-display') && t.hasClass('calendar')) || (!t.hasClass('change-display') && initCode.indexOf('calendar') !== -1)) {
    		code += codeCtn.attr('data-calendar');
    	}
    	if ((t.hasClass('change-type') && t.hasClass('dynamic')) || (!t.hasClass('change-type') && initCode.indexOf('dynamic') !== -1)) {
    		code += codeCtn.attr('data-dynamic');
    	}
		code += codeCtn.attr('data-suffix');
    	
    	ctn.find('textarea').html(code);
    };

	var init = function () {
		MG2.ColorPicker.init();
		promotionsAllActionsBtn = $('.promotions-one-event-outer-ctn .table-action-popup-btn');
		promotionsActionBtn = $('.table-promotions-action-btn');
		outerCtn = $('.promotions-action-ctn.generate-buy-btn');
		buttonChoiceBtn = $('.button-style-choice-btn');
		buttonSizeRangeBtn = $('.custom-btn-range-input');
		colorPickerBtn = $('.promotions .mg2-color-current');
		buttonTextInput = $('.promotions-custom-button-text-input');
		backToButtonChoicesBtn = $('.promotions-custom-button-back-to-choices-btn');
		eventDisplayBtn = $('.promotions-profile-events-style-btn');
		eventTypeBtn = $('.change-type');

		promotionsAllActionsBtn.click(blackoutPromotionsEvents);
		promotionsActionBtn.click(showActionRelatedContent);
		buttonChoiceBtn.click(getButtonChoice);
		buttonSizeRangeBtn.on('input', changeButtonSize);
		buttonSizeRangeBtn.on('change', changeButtonSize); // IE
		colorPickerBtn.click(changeButtonColor);
		buttonTextInput.keyup(changeButtonText);
		backToButtonChoicesBtn.click(showAllButtonChoices);
		eventTypeBtn.change(changeEventDisplayStyle);
		eventDisplayBtn.click(changeEventDisplayStyle);
        
        addFavorTicketsBtn = $(".add-favor-tickets");
        addFavorTicketsBtn.on("click", addFavorTickets);
        
        addFavorTicketsRecipientBtn = $(".promotions-tickets-add-recipient-btn");
        addFavorTicketsRecipientBtn.on("click", addFavorTicketsRecipient);
        
        delFavorTicketsRecipientBtn = $(".del-free-ticket-line");
        delFavorTicketsRecipientBtn.on("click", delFavorTicketsRecipient);
	};
	
	$(window).on('load',function(){
		init();
	});
})(jQuery);